import theme from "styles/theme";

export enum SaleChannelId {
  DedicatedFleet = 1,
  Spot = 2,
  Resale = 3,
  Collaborative = 4,
  AS = 5,
  Input = 6,
  CMove = 7,
  InputLog = 8,
  Others = 9,
  T4 = 10,
}

type SaleChannelConfig = {
  translationId: string;
  tagColor: string;
  truckColor: string;
  tagTextColor?: string;
  tagBorderColor?: string;
};

export const DEFAULT_TRUCK_COLOR = "#01346A";
export const MANEUVER_TRUCK_COLOR = "#8F0800";
export const OTHERS_TRUCK_COLOR = "#77198E";

export const saleChannelConfigById: Partial<Record<SaleChannelId, SaleChannelConfig>> = {
  [SaleChannelId.DedicatedFleet]: {
    translationId: "fleet_channel_dedicated_fleet",
    tagColor: theme["@fixed-fleet-sale-channel"],
    truckColor: DEFAULT_TRUCK_COLOR,
  },
  [SaleChannelId.Spot]: {
    translationId: "fleet_channel_spot",
    tagColor: theme["@spot-sale-channel"],
    truckColor: "#8F0800",
  },
  [SaleChannelId.Resale]: {
    translationId: "fleet_channel_resale",
    tagColor: theme["@resale-sale-channel"],
    truckColor: "#006C38",
  },
  [SaleChannelId.Collaborative]: {
    translationId: "fleet_channel_collaborative",
    tagColor: theme["@collaborative-sale-channel"],
    truckColor: DEFAULT_TRUCK_COLOR,
  },
  [SaleChannelId.AS]: {
    translationId: "fleet_channel_as",
    tagColor: theme["@as-sale-channel"],
    truckColor: "#CF9202",
  },
  [SaleChannelId.Input]: {
    translationId: "fleet_channel_supplies",
    tagColor: theme["@input-sale-channel"],
    truckColor: "#001616",
  },
  [SaleChannelId.CMove]: {
    translationId: "fleet_channel_cmove",
    tagColor: theme["@cMove-sale-channel"],
    truckColor: "#8F0800",
  },
  [SaleChannelId.InputLog]: {
    translationId: "fleet_channel_insumo_log",
    tagColor: theme["@logInput-sale-channel"],
    truckColor: "#001616",
  },
  [SaleChannelId.Others]: {
    translationId: "fleet_channel_others",
    tagColor: theme["@others-sale-channel"],
    tagTextColor: theme.colors.text,
    tagBorderColor: theme.colors.text,
    truckColor: OTHERS_TRUCK_COLOR,
  },
  [SaleChannelId.T4]: {
    translationId: "fleet_channel_t4",
    tagColor: theme["@resale-sale-channel"],
    truckColor: "#006C38",
  },
};

export const getSaleChannelConfig = (saleChannelId?: number | null) => {
  if (saleChannelId == null) return undefined;

  return saleChannelConfigById[saleChannelId as SaleChannelId];
};

export const getSaleChannelTruckColor = (saleChannelId?: number | null) => getSaleChannelConfig(saleChannelId)?.truckColor ?? DEFAULT_TRUCK_COLOR;
